(() => {
  const initProductRail = (root = document) => {
    const rails = [];

    if (root && root.matches && root.matches('[data-af-product-rail]')) {
      rails.push(root);
    }

    if (root && root.querySelectorAll) {
      root.querySelectorAll('[data-af-product-rail]').forEach((rail) => {
        if (!rails.includes(rail)) rails.push(rail);
      });
    }

    rails.forEach((rail) => {
      const viewport = rail.querySelector('[data-af-product-rail-viewport]');
      const track = rail.querySelector('[data-af-product-rail-track]');
      const prev = rail.querySelector('[data-af-product-rail-prev]');
      const next = rail.querySelector('[data-af-product-rail-next]');

      if (!viewport || !track) return;

      const alreadyInitialized = rail.dataset.afProductRailInitialized === 'true';

      const getStep = () => {
        const firstItem = track.querySelector('.af-product-rail__item');
        if (!firstItem) return viewport.clientWidth * 0.8;

        const styles = getComputedStyle(track);
        const gap = parseFloat(styles.columnGap || styles.gap || 0) || 0;
        return firstItem.getBoundingClientRect().width + gap;
      };

      const updateControls = () => {
        if (!prev || !next) return;

        const maxScroll = Math.max(0, viewport.scrollWidth - viewport.clientWidth);
        prev.disabled = viewport.scrollLeft <= 2;
        next.disabled = viewport.scrollLeft >= maxScroll - 2;
      };

      if (!alreadyInitialized) {
        prev?.addEventListener('click', () => {
          viewport.scrollBy({ left: -getStep(), behavior: 'smooth' });
        });

        next?.addEventListener('click', () => {
          viewport.scrollBy({ left: getStep(), behavior: 'smooth' });
        });

        viewport.addEventListener('scroll', updateControls, { passive: true });
        window.addEventListener('resize', updateControls);

        rail.dataset.afProductRailInitialized = 'true';
      }

      updateControls();
    });

    if (window.theme && typeof window.theme.initQuickView === 'function') {
      window.theme.initQuickView(document);
    }
  };

  const boot = () => {
    initProductRail(document);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  window.addEventListener('load', boot, { once: true });

  document.addEventListener('shopify:section:load', (event) => {
    initProductRail(event.target);
  });

  document.addEventListener('shopify:section:select', (event) => {
    initProductRail(event.target);
  });
})();
